<article>
  <div class="row text-center">
    <app-form action="/login" [handler]="this">
      <div class="form-inner">
        <h1>{{reason}}</h1>
        
        <error-message [host]="this"></error-message>
        <!-- 
        <div class="alert-slidable alert alert-danger" [class.visible]="error">
          {{errorMessage}}
        </div>
        -->

        <div class="form-group">
          <input type="text" class="form-control" id="username" name="username" 
            placeholder="Email" [(ngModel)]="username" autofocus>
        </div>

        <div class="form-group">
          <input type="password" name="password" class="form-control" id="password" 
            placeholder="Password" [(ngModel)]="password">
        </div>

        <div class="remember-me">
          <label>
            <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe">
            <span>Remember Me</span>
          </label>
        </div>

        <div class="forgot">
          <a href="javascript:;" (click)="showForgot()">Forgot Password?</a>
        </div>
        <div class="actions">
          <tyt-form-submit-button>Sign In</tyt-form-submit-button>
        </div>
        <p>Don't have an account? <a (click)="close()" routerLink="/signup">Sign up now!</a></p> 


        <div>
          <div>
            Or sign in with:
          </div>

          <ng-container *ngIf="enableYouTubeLogin">
              <div class="social-signups">
                <a [href]="oauthUrlFor('youtube')" class="youtube"  aria-label="Sign in with YouTube">
                  <i class="fab fa-youtube"></i>
                  <img src="/assets/google_signin_buttons/yt_logo_mono_dark.png" alt="YouTube" />
                </a>
                <a [href]="oauthUrlFor('facebook')" class="facebook" aria-label="Sign in with Facebook">
                  <i class="fab fa-facebook-f"></i>
                  <span class="text">Facebook</span>
                </a>
                <a [href]="oauthUrlFor('twitter')" class="twitter"  aria-label="Sign in with Twitter">
                  <i class="fab fa-twitter"></i>
                  <span class="text">Twitter</span>
                </a>
              </div>

              <a [href]="oauthUrlFor('google')" class="google"  aria-label="Sign in with Google">
                <img style="height: 46px" src="/assets/google_signin_buttons/web/2x/btn_google_signin_dark_normal_web@2x.png" alt="Sign in with Google" />
              </a>
          </ng-container>
          <ng-container *ngIf="!enableYouTubeLogin">
              <div class="social-signups">
                <a [href]="oauthUrlFor('facebook')" class="facebook" aria-label="Sign in with Facebook">
                  <i class="fab fa-facebook-f"></i>
                  <span class="text">Facebook</span>
                </a>
                <a [href]="oauthUrlFor('google')" class="google"  aria-label="Sign in with Google">
                    <i class="fab fa-google"></i>
                  <span class="text">Google</span>
                </a>
                <a [href]="oauthUrlFor('twitter')" class="twitter"  aria-label="Sign in with Twitter">
                  <i class="fab fa-twitter"></i>
                  <span class="text">Twitter</span>
                </a>
              </div>

          </ng-container>
        </div>

        <tyt-staging-note [shown]="true">
          This is the staging installation, your account details are not synchronized with the production installation. 
          Your password may be different than on TYT.com. You can also sign up and create additional 
          test accounts to test different parts of the system.
        </tyt-staging-note>
      </div>
    </app-form>
  </div>
</article>